import { render } from "./Logo.vue?vue&type=template&id=9d0e7566&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"

import "./Logo.vue?vue&type=style&index=0&id=9d0e7566&scoped=true&lang=scss"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d0e7566"],['__file',"src/components/black-friday/Logo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9d0e7566"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9d0e7566', __exports__)) {
    console.log('reload')
    api.reload('9d0e7566', __exports__)
  }
  
  module.hot.accept("./Logo.vue?vue&type=template&id=9d0e7566&scoped=true", () => {
    console.log('re-render')
    api.rerender('9d0e7566', render)
  })

}


export default __exports__